export default {
  'menu.welcome': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登錄',
  'menu.register': '註冊',
  'menu.register-result': '註冊結果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu': '平台',
  'menu.order': '訂單',
  'menu.order-fulfillment': '平台訂單',
  'menu.order-fulfillment.platform-order': '平台訂單(所有)',
  'menu.order-fulfillment.fulfillment-request': '履行請求',
  'menu.order-fulfillment.wms-pre-order': '待發送到-WMS',
  'menu.order-fulfillment.wms-accepted': '處理中(WMS)',
  'menu.order-fulfillment.wms-inprogess': 'WMS Inprogress',
  'menu.order-fulfillment.fulfillment-order': '新訂單(OMS)',
  'menu.order-fulfillment.ready-to-ship': '準備發貨(Label)',
  'menu.order-fulfillment.packed-order': '已包裝訂單',
  'menu.order-fulfillment.shipped-order': '已發送訂單',
  'menu.order-fulfillment.orderDetail': '訂單詳情',
  'menu.order-fulfillment.rejected-label': '失敗 Label',
  'menu.order-handle-stock': '訂單庫存處理',
  'menu.order-handle-stock.require-allocate-stock': '待分配庫存',
  'menu.order-handle-stock.allocated-stock': '已分配庫存',
  'menu.order-handle-stock.interface-pack-stock': '已打包（回饋）',
  'menu.order-handle-stock.require-ship-stock': '待發貨',
  'menu.order-handle-stock.interface-cancel-stock': '異常/取消（回饋）',
  'menu.order-handle-stock.cancelled-by-platform': '平台取消',
  'menu.inventory': '庫存',
  'menu.inventory.platform-inventory': '平台庫存',
  'menu.inventory.interface-inventory': '庫存(SAP-回傳)',
  'menu.platform-product': '平台產品',
  'menu.report': '報表',
  'menu.store': '店鋪',
  'menu.marketplace-commission': '提成',
  'menu.marketplace-category': '平台分類',
  'menu.payment-gateway': '支付網關',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.settings': '個人設置',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
  'menu.settings': '設置',
};
